// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../config/screen';

// Components
import { Col } from '../../../layout/elements/Col';

export const Container = styled(Col)`
  border-radius: 8px;
  padding-bottom: 1rem;
  padding: 0 2rem 1rem;

  @media (min-width: ${BREAKPOINTS.lg}px) {
    padding: 0 2.5rem 1.25rem;
  };
`;

export const Content = styled.div`
  background-color: ${({ theme }) => theme.color.settings.moduleBackgroundColor};
  border-radius: 8px;
  width: 100%;

  // Desktop: reduce width to 60%
  @media (min-width: ${BREAKPOINTS.lg}px) {
    width: 60%;
  };
`;

export const TitleContainer = styled.div`
  padding: 1rem 1.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.color.settings.unitSystemContentBorderColor};
`;

export const ActionsContainer = styled.div`
  padding: 1.5rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
